import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[appTrim]",
})
export class TrimDirective {
  private readonly el!: NgControl;

  constructor(ngColtrol: NgControl) {
    this.el = ngColtrol;
  }
  @HostListener("blur") onBlur() {
    if (!this.el.control) {
      return;
    }
    this.el.control.setValue(this.el.control.value.trim());
  }
}
